'use strict';

angular.module('domain.soliditet', ['ngRoute', 'upResources', 'security.authorization']).config([
	'$stateProvider',
	function ($stateProvider) {
		var sectionFn = function (accountSelf) {
			if (!accountSelf.products.crm && accountSelf.features.soliditet) {
				return 'market';
			}
			return 'sale';
		};

		// Empty twin of the React /find-prospects route, kept for $state.go('findProspects') callers.
		// The access resolves keep users without access on their current page instead of navigating.
		$stateProvider.state('findProspects', {
			url: '/:customerId/find-prospects/',
			template: '<div></div>',
			section: 'sale',
			sectionFn: sectionFn,
			resolve: {
				authUser: [
					'$routeGuard',
					function ($routeGuard) {
						return $routeGuard.requireUser();
					}
				],
				multiSoliditetActivated: [
					'AppService',
					'$q',
					function (AppService, $q) {
						return AppService.loadedPromise.then(function () {
							var self = AppService.getSelf();
							var multiSoliditetActive = self.userParams.multiSoliditetAccess;
							var soliditetActive =
								self.userParams.soliditetIsActive && AppService.getMetadata().params.soliditetIsActive;
							if (soliditetActive && (self.administrator || multiSoliditetActive)) {
								return $q.when(true);
							}
							return $q.reject(false);
						});
					}
				],
				isAvailable: [
					'FeatureHelper',
					function (FeatureHelper) {
						return FeatureHelper.placeholder(FeatureHelper.Feature.SOLIDITET);
					}
				]
			}
		});
	}
]);
